import list from './list';
import edit from './edit';
import create from './create';
import { default as icon } from '@mui/icons-material/Person';

export const User = {
	list, edit, create, icon
};

export default User;